export class ComplianceAndOperationsFakeDb {
  public static operations = [];
}
